module.exports = __webpack_public_path__ + "static/media/feelingProud.e589b10e.svg";